const initialForm = {
	login: {
		text: {
			header: 'Masuk',
			subHeader: 'Silakan masuk dengan akun Pendana',
		},
		form: [
			{
				id: 'phoneNumber',
				formType: 'phone',
				placeholder: 'Nomor Ponsel',
				name: 'phoneNumber',
				apiErrorMessage: '',
				value: '',
			},
			{
				id: 'password',
				formType: 'password',
				placeholder: 'Kata Sandi',
				name: 'password',
				apiErrorMessage: '',
				value: '',
			},
		],
		button: 'Masuk',
	},
	generateOtp: {
		text: {
			header: 'Lupa Kata Sandi',
			subHeader:
				'Silakan masukan nomor ponsel Anda untuk mengatur ulang kata sandi baru',
		},
		form: [
			{
				id: 'phoneNumber',
				formType: 'phone',
				placeholder: 'Nomor Ponsel',
				name: 'phoneNumber',
				apiErrorMessage: '',
				value: '',
			},
		],
		button: 'Selanjutnya',
	},
	newPassword: {
		text: {
			header: 'Atur Ulang Kata Sandi',
			subHeader: 'Silakan masukan kata sandi baru Anda',
		},
		form: [
			{
				id: 'newPassword',
				formType: 'password',
				placeholder: 'Kata Sandi Baru',
				name: 'newPassword',
				apiErrorMessage: '',
				value: '',
			},
			{
				id: 'confirmPassword',
				formType: 'password',
				placeholder: 'Konfirmasi Kata Sandi Baru',
				name: 'confirmPassword',
				apiErrorMessage: '',
				value: '',
			},
		],
		button: 'Atur Ulang Kata Sandi',
	},
};

export default initialForm;
